<template>
  <button
    class="rounded-md border border-primary text-primary px-4 py-1 flex items-center gap-x-2"
    :class="wrapperClass"
  >
    <slot name="icon"> </slot>
    <span class="px-1.5 ltr:font-sans tracking-wide">
      {{ label }}
    </span>
  </button>
</template>
<script setup>
defineProps({
  label: String,
  wrapperClass: {
    type: String
  }
})
</script>
<script>
export default {
  name: 'BorderButton'
}
</script>
<style lang="scss" scoped></style>
